import { createContext, useEffect, useState } from "react";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children, initialUser = {} }) => {
  const [user, setUser] = useState(initialUser);

  useEffect(() => {
    if (!initialUser) {
      const stored = localStorage.getItem("userData");
      console.log(stored);
      if (stored) setUser(JSON.parse(stored));
    }
  }, [initialUser]);

  const clearUser = () => {
    localStorage.removeItem("userData");
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, setUser, clearUser }}>{children}</AuthContext.Provider>;
};
